document.addEventListener('DOMContentLoaded', function () {
    scrollNav()
    navegacionFija()
})


function scrollNav() {
    const enlaces = document.querySelectorAll('.navegacion-principal a')

    enlaces.forEach( enlace => {
        enlace.addEventListener('click', function(e) {
            e.preventDefault()
            const seccion = document.querySelector(e.target.attributes.href.value)
            console.log(seccion)

            seccion.scrollIntoView({
                behavior : "smooth"
            })
        })
    })
}

function navegacionFija() {
    const barra = document.querySelector('.header')

    const observer = new IntersectionObserver(function(entries){
        console.log(entries)

        if (entries[0].isIntersecting) {
            barra.classList.remove('fijo')
        }else {
            barra.classList.add('fijo')
        }
    })


    observer.observe(document.querySelector('.contenido-festival'))
}